import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStackedBarChartAxis2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconStackedBarChartAxis2"><Path d="M3.75 3C4.16421 3 4.5 3.33579 4.5 3.75V19.5H20.25C20.6642 19.5 21 19.8358 21 20.25C21 20.6642 20.6642 21 20.25 21H3.75C3.33579 21 3 20.6642 3 20.25V3.75C3 3.33579 3.33579 3 3.75 3Z" fill="currentColor"/><Path d="M11 9C11.5523 9 12 9.44772 12 10V18H7V10C7 9.44772 7.44772 9 8 9H11Z" fill="currentColor"/><Path d="M17 6C17.5523 6 18 6.44772 18 7V18H13V7C13 6.44772 13.4477 6 14 6H17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStackedBarChartAxis2;
